import { DataService } from '../../../services/data_service';
import { EmissionsfaktorenImport } from './EmissionsfaktorenImport';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';
import { WUploadButton } from '../../../core/elements/WUploadButton';

interface DatenverwaltungKlimaScope3Props extends React.ClassAttributes<any> {
    data: any;
    entity: string;
}

interface DatenverwaltungKlimaScope3State extends React.ClassAttributes<any> {
    allCheckboxChecked: boolean;
    data: any[];
    dataImport: string;
    selectedTids: any;
    params: any;
}

export class DatenverwaltungKlimaScope3 extends React.Component<DatenverwaltungKlimaScope3Props, DatenverwaltungKlimaScope3State> {

    constructor(props: any) {
        super(props);
        this.state = {
            allCheckboxChecked: false,
            data: null,
            dataImport: null,
            selectedTids: {},
            params: {}
        };
        this.isRowSelected = this.isRowSelected.bind(this);
        this.onDataLoaded = this.onDataLoaded.bind(this);
        this.onRowSelect = this.onRowSelect.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private entities: any = {
        [IDs.ENT_CO2_SCOPE3_FAKTOREN_MATERIAL]: {
            autoCreate: { unterkategorie_tid: true },
            uniques: [{ columns: ['name', 'jahr', 'quelle'], values: { wert: true } }]
        },
        [IDs.ENT_CO2_SCOPE3_FAKTOREN_GUETER]: { uniques: [{ columns: ['name', 'jahr', 'quelle'], values: { wert: true } }] },
        [IDs.ENT_CO2_SCOPE3_FAKTOREN_TRANSPORT]: {
            uniques: [
                { columns: ['info', 'jahr', 'quelle'], required: { wert: true, quelle: true }, values: { wert: true } },
                {
                    columns: ['info', 'jahr', 'quelle_person'], required: { wert_person: true, quelle_person: true },
                    values: { wert_person: true }
                },
                { columns: ['info', 'jahr', 'quelle_euro'], required: { wert_euro: true, quelle_euro: true }, values: { wert_euro: true } }
            ]
        },
        // [IDs.ENT_CO2_SCOPE3_FAKTOREN_ABFAELLE]: { uniques: [{ columns: ['name', 'jahr', 'quelle'], values: { wert: true } }] },
        [IDs.ENT_CO2_SCOPE3_FAKTOREN_ABFAELLE]: {
            uniques: [
                { columns: ['name', 'kategorie', 'unterkategorie', 'jahr', 'quelle', 'datenqualitaet'], values: { wert: true } },
                {
                    columns: ['name', 'kategorie', 'unterkategorie', 'jahr', 'quelle_recycling', 'datenqualitaet_recycling'],
                    values: { wert_recycling: true }
                },
                {
                    columns: ['name', 'kategorie', 'unterkategorie', 'jahr', 'quelle_deponie', 'datenqualitaet_deponie'],
                    values: { wert_deponie: true }
                },
                {
                    columns: ['name', 'kategorie', 'unterkategorie', 'jahr', 'quelle_verbrennen', 'datenqualitaet_verbrennen'],
                    values: { wert_verbrennen: true }
                },
                {
                    columns: ['name', 'kategorie', 'unterkategorie', 'jahr', 'quelle_kompostieren', 'datenqualitaet_kompostieren'],
                    values: { wert_kompostieren: true }
                }
            ]
        },
        [IDs.ENT_CO2_SCOPE3_FAKTOREN_REISEN_ENTFERNUNG]: {
            uniques: [
                { columns: ['info', 'kraftstoff', 'jahr', 'quelle'], required: { wert: true, quelle: true }, values: { wert: true } },
                {
                    columns: ['info', 'kraftstoff', 'jahr', 'quelle_euro'], required: { wert_euro: true, quelle_euro: true },
                    values: { wert_euro: true }
                }
            ]
        },
        [IDs.ENT_CO2_SCOPE3_FAKTOREN_REISEN_UEBERNACHTUNG]: { uniques: [{ columns: ['info', 'jahr', 'quelle'], values: { wert: true } }] },
        [IDs.ENT_CO2_SCOPE3_FAKTOREN_PENDELN]: {
            uniques: [{ columns: ['jahr', 'transportmittel', 'kraftstoff', 'quelle'], values: { wert: true } }]
        },
        [IDs.ENT_CO2_SCOPE3_FAKTOREN_TRANSPORT_UNTERKUNFT]: {
            uniques: [{ columns: ['unterkunft', 'jahr', 'quelle'], values: { wert: true } }]
        },
        [IDs.ENT_CO2_SCOPE3_FAKTOREN_ANGEMIETETE_RAEUMLICHKEITEN]: {
            uniques: [
                {
                    columns: ['nutzungsart', 'jahr', 'quelle_heizenergie'], required: { heizenergie: true, quelle_heizenergie: true },
                    values: { heizenergie: true }
                },
                {
                    columns: ['nutzungsart', 'jahr', 'quelle_warmwasser'], required: { warmwasser: true, quelle_warmwasser: true },
                    values: { warmwasser: true }
                },
                {
                    columns: ['nutzungsart', 'jahr', 'quelle_beleuchtung'], required: { beleuchtung: true, quelle_beleuchtung: true },
                    values: { beleuchtung: true }
                },
                {
                    columns: ['nutzungsart', 'jahr', 'quelle_luftfoerderung'],
                    required: { luftfoerderung: true, quelle_luftfoerderung: true }, values: { luftfoerderung: true }
                },
                {
                    columns: ['nutzungsart', 'jahr', 'quelle_kuehlkaelte'], required: { kuehlkaelte: true, quelle_kuehlkaelte: true },
                    values: { kuehlkaelte: true }
                },
                {
                    columns: ['nutzungsart', 'jahr', 'quelle_hilfsenergie_kaelte'],
                    required: { hilfsenergie_kaelte: true, quelle_hilfsenergie_kaelte: true }, values: { hilfsenergie_kaelte: true }
                },
                {
                    columns: ['nutzungsart', 'jahr', 'quelle_befeuchtung'], required: { befeuchtung: true, quelle_befeuchtung: true },
                    values: { befeuchtung: true }
                },
                {
                    columns: ['nutzungsart', 'jahr', 'quelle_arbeitshilfen'], required: { arbeitshilfen: true, quelle_arbeitshilfen: true },
                    values: { arbeitshilfen: true }
                }
            ]
        },
        [IDs.ENT_CO2_SCOPE3_FAKTOREN_ANGEMIETETE_FAHRZEUGE]: {
            uniques: [
                { columns: ['info', 'kraftstoff', 'jahr', 'quelle'], required: { wert: true, quelle: true }, values: { wert: true } },
                {
                    columns: ['info', 'kraftstoff', 'jahr', 'quelle_s3'], required: { wert_s3: true, quelle_s3: true },
                    values: { wert_s3: true }
                }
            ]
        }
    };

    componentDidMount(): void {
        this.init();
    }

    delData(): void {
        const selectedTids: any = this.state.selectedTids || {};
        const tids: any[] = [];

        Object.keys(selectedTids).forEach((tid: string) => {
            if (selectedTids[tid]) {
                tids.push({ tid: +tid });
            }
        });
        
        if (confirm(`Datensätze [${tids.length}] wirklich löschen?`)) {
            this.dataService.delDataList(
                this.props.entity, tids,
                () => {
                    this.triggerService.fire('reload', this.props.entity);
                    this.setState({ selectedTids: {} }, () => alert(`Datensätze [${tids.length}] wurden gelöscht.`));
                },
                IDs.MOD_ETOOL_ADMIN
            );
        }
    }

    filterOptions(options: any[], key: string, data: any): any[] {
        return key === 'standort_tid'
            ? (options || []).filter((item: any) => (item.mandant || null) === (data.mandant || null))
            : options;
    }

    init(): void {
        const params: any = this.entities[this.props.entity] || {};

        if (!Object.keys(params).length) {
            return;
        }
        this.setState({ params });
    }

    isRowSelected(row: any): boolean {
        const selectedTids: any = this.state.selectedTids || {};

        return selectedTids.all && !selectedTids[(row || {}).tid];
    }

    onDataLoaded(dataImport: string): void {
        this.setState({ dataImport });
    }

    onRowSelect(row: any, selected: boolean, selectedTids: any): void {
        this.setState({
            selectedTids: selectedTids || {},
            allCheckboxChecked: (row || {}).tid === 'all' && selected
        });
    }

    render(): JSX.Element {
        return <>
            {!this.state.dataImport &&
                <WFormsTableWrapper
                    entity={this.props.entity}
                    module={IDs.MOD_ETOOL_ADMIN}
                    actions={['edit', 'add', 'delete']}
                    externalHeaderElements={[this.renderDeleteButton(), this.renderUploadButton()]}
                    customClass='Custom-ETA'
                    formLayout='flowV2'
                    onDataLoaded={(data: any[]) => this.setState({ data })}
                    filterOptions={this.filterOptions}
                    enableRowCheckbox
                    onRowSelect={this.onRowSelect}
                    isRowSelected={this.isRowSelected}
                    allCheckboxChecked={this.state.allCheckboxChecked}
                    checkedRows={this.state.selectedTids}
                    onDelDone={() => this.setState({ selectedTids: {} }, () => this.triggerService.fire('reload', this.props.entity))}
                    onSaveDone={() => this.triggerService.fire('reload', this.props.entity)}
                    showColumnsHelp
                />
            }
            {this.state.dataImport && this.renderImport()}
        </>;
    }

    renderDeleteButton(): JSX.Element {
        const label: string = 'Löschen';
        const selectedTids: any = this.state.selectedTids || {};
        const selectedAnzahl: number = Object.keys(selectedTids)
            .reduce((anzahl: number, tid: string) => anzahl + (selectedTids[tid]), 0);
        const disabled: boolean = selectedAnzahl === 0;
        const styleProps: React.CSSProperties = { ...(disabled ? { backgroundColor: 'lightgray', cursor: 'not-allowed' } : {}) };

        return (
            <WActionButton
                tooltip='Datensätze löschen'
                label={label}
                action='delete'
                key='delete'
                insideText={label}
                indicatorFullNumber
                indicatorValue={selectedAnzahl}
                indicatorColor={selectedAnzahl > 0 ? '#0a0' : '#aaa'}
                disabled={selectedAnzahl === 0}
                styleProps={styleProps}
                onAction={() => this.delData()}
            />
        );
    }

    renderImport(): JSX.Element {
        return (
            <EmissionsfaktorenImport
                data={{ ...(this.props.data || {}), [this.props.entity]: this.state.data || [] }}
                dataImport={this.state.dataImport}
                entity={this.props.entity}
                onCancel={() => this.setState({ dataImport: undefined })}
                onSaveDone={() => this.setState({ dataImport: undefined }, () => this.triggerService.fire('reload', this.props.entity))}
                params={this.state.params}
            />
        );
    }

    renderUploadButton(): JSX.Element {
        const disabled: boolean = !Object.keys(this.state.params).length;
        const tooltip: string = disabled ? 'Keine Definition für die Tabelle gefunden!' : 'Emissionsfaktoren hochladen';

        return (
            <WUploadButton
                label='Upload Emissionsfaktoren'
                insideText='Upload Emissionsfaktoren'
                tooltip={tooltip}
                key='upload'
                disabled={disabled}
                onDataLoaded={this.onDataLoaded}
            />
        );
    }
}
